const { PROC_STEP, PROC_CONTRACTS } = require('utilities/tagging');

export const analyticsId = {
  SOLIDARITY_CARD_STEP_1_VIEW: 'SOLIDARITY_CARD_STEP_1_VIEW',
  SOLIDARITY_CARD_STEP_2_VIEW: 'SOLIDARITY_CARD_STEP_2_VIEW',
  SOLIDARITY_CARD_STEP_3_VIEW: 'SOLIDARITY_CARD_STEP_3_VIEW',
  SOLIDARITY_CARD_STEP_4_VIEW: 'SOLIDARITY_CARD_STEP_4_VIEW',
  SOLIDARITY_CARD_STEP_5_VIEW: 'SOLIDARITY_CARD_STEP_5_VIEW',
  SOLIDARITY_CARD_WIZARD_ERROR: 'SOLIDARITY_CARD_WIZARD_ERROR',
  SOLIDARITY_CARD_WIZARD_SUCCESS: 'SOLIDARITY_CARD_WIZARD_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'contractingCard',
  tipoPagina: 'tarjeta-solidaria',
  tipoProceso: PROC_CONTRACTS,
  tipoUsuario: 'cliente',
  estadoUsuario: 'logado',
  zonaWeb: 'zona privada',
  versionSitio: 'desktop',
  detalleProceso: productName,
  productName,
});

export const catalogue = {
  [analyticsId.SOLIDARITY_CARD_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_precontractual',
    pageName: '/contractingCard/step1/precontractual',
    processStep: 'step1',
    processDetail: 'precontractual',
    pasoProceso: PROC_STEP + '1',
  }),
  [analyticsId.SOLIDARITY_CARD_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_card_NGO_selection',
    pageName: '/contractingCard/step2/cardNGOSelection',
    processStep: 'step2',
    processDetail: 'cardNGOSelection',
    pasoProceso: PROC_STEP + '2',
  }),
  [analyticsId.SOLIDARITY_CARD_STEP_3_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_configuration',
    pageName: '/contractingCard/step3/configuration',
    processStep: 'step3',
    processDetail: 'configuration',
    pasoProceso: PROC_STEP + '3',
  }),
  [analyticsId.SOLIDARITY_CARD_STEP_4_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_shipment',
    pageName: '/contractingCard/step4/shipment',
    processStep: 'step4',
    processDetail: 'shipment',
    pasoProceso: PROC_STEP + '4',
  }),
  [analyticsId.SOLIDARITY_CARD_STEP_5_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_confirmation',
    pageName: '/contractingCard/step5/confirmation',
    processStep: 'step5',
    processDetail: 'confirmation',
    pasoProceso: PROC_STEP + '5',
  }),
  [analyticsId.SOLIDARITY_CARD_WIZARD_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/contractingCard/error',
    processStep: 'error',
    errorCategory: 'requestError',
    errorDescription: errorMessage,
  }),
  [analyticsId.SOLIDARITY_CARD_WIZARD_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/contractingCard/success',
    processStep: 'success',
  }),
};
